/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `SET_EDITOR_SENDING` - Set Editor Sending
 *   * `SET_EDITOR_SENDING_FAILED` - Set Editor Sending Failed
 *   * `SET_EDITOR_RECEIVING` - Set Editor Receiving
 *   * `SET_EDITOR_RECEIVING_FAILED` - Set Editor Receiving Failed
 *   * `SET_EDITOR_ACCEPTED` - Set Editor Accepted
 *   * `SET_EDITOR_REJECTED` - Set Editor Rejected
 *   * `PREPARED_TO_SEND` - Prepared To Send
 *   * `CHANGE_AREA_SENDING` - Change Area Sending
 *   * `CHANGE_AREA_SENDING_FAILED` - Change Area Sending Failed
 *   * `CHANGE_AREA_RECEIVING` - Change Area Receiving
 *   * `CHANGE_AREA_RECEIVING_FAILED` - Change Area Receiving Failed
 *   * `CHANGE_AREA_ACCEPTED` - Change Area Accepted
 *   * `CHANGE_AREA_REJECTED` - Change Area Rejected
 *   * `REVOKE_AREA_FAILED` - Revoke Area Failed
 * ```
 */
export const UrcenyEditorZpsStatesEnum = {
  SET_EDITOR_SENDING: 'SET_EDITOR_SENDING',
  SET_EDITOR_SENDING_FAILED: 'SET_EDITOR_SENDING_FAILED',
  SET_EDITOR_RECEIVING: 'SET_EDITOR_RECEIVING',
  SET_EDITOR_RECEIVING_FAILED: 'SET_EDITOR_RECEIVING_FAILED',
  SET_EDITOR_ACCEPTED: 'SET_EDITOR_ACCEPTED',
  SET_EDITOR_REJECTED: 'SET_EDITOR_REJECTED',
  PREPARED_TO_SEND: 'PREPARED_TO_SEND',
  CHANGE_AREA_SENDING: 'CHANGE_AREA_SENDING',
  CHANGE_AREA_SENDING_FAILED: 'CHANGE_AREA_SENDING_FAILED',
  CHANGE_AREA_RECEIVING: 'CHANGE_AREA_RECEIVING',
  CHANGE_AREA_RECEIVING_FAILED: 'CHANGE_AREA_RECEIVING_FAILED',
  CHANGE_AREA_ACCEPTED: 'CHANGE_AREA_ACCEPTED',
  CHANGE_AREA_REJECTED: 'CHANGE_AREA_REJECTED',
  REVOKE_AREA_FAILED: 'REVOKE_AREA_FAILED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UrcenyEditorZpsStatesEnum = ValuesOf<typeof UrcenyEditorZpsStatesEnum>;

export type UrcenyEditorZpsStatesEnumRequest = UrcenyEditorZpsStatesEnum;
export type UrcenyEditorZpsStatesEnumResponse = UrcenyEditorZpsStatesEnum;
